<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.product_name" placeholder="钱币名称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_appraisal" placeholder="评级编码" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="productName" label="钱币名称" width="250"></el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码" width="110"></el-table-column>
            <el-table-column label="创建时间" width="160">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.sendDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="adminName" label="代卖人" width="100"></el-table-column>
            <el-table-column prop="sendType" label="类型" width="100">
                <template slot-scope="scope">
                    {{ getProductStatusName(scope.row.sendType) }}
                </template>
            </el-table-column>
            <el-table-column label="发货时间" width="160">
                <template slot-scope="scope">
                    {{ scope.row.sendPostDate ? convertToDate(scope.row.sendPostDate) : "-" }}
                </template>
            </el-table-column>
            <el-table-column prop="sendPost" label="物流信息">
                <template slot-scope="scope">
                    <div>{{ scope.row.sendAddress ? scope.row.sendAddress : "-" }}</div>
                    <div>{{ scope.row.sendPost ? scope.row.sendPost : "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="sendMemo" label="备注" width="100"></el-table-column>
            <el-table-column prop="productImages" label="钱币底图" width="85">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">发货</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="收货地址">
                        <el-input v-model="handleInfo.sendAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="快递单号">
                        <el-input v-model="handleInfo.sendPost"></el-input>
                    </el-form-item>
                    <el-form-item label="发货备注">
                        <el-input v-model="handleInfo.sendMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, uploadMixin, imageMixin, enumMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "SEND";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>